import React, {useEffect, useState} from 'react'
import {PageWrap} from "../../Components";
import BoardList from "../../Containers/Board/BoardList";
import {REPO} from "../../Repository/repo";
import {TablePaginationConfig} from "antd";
import {FilterValue, SorterResult} from "antd/es/table/interface";
import {BranchListModel} from "../../Model/BranchModel";
import { boardTypeText, queryAdd} from "../../Helper/Helper";
import {DEFAULT_LIST_COUNT} from "../../Constant/Common";
import {useStore} from "../../Hooks";
import {useLocation, useNavigate} from "react-router-dom";
import {useQuery} from "../../Hooks/useQuery";
import {BoardItemModel} from "../../Model/BoardModel";

const BoardListPage = () => {
    const [data, setData] = useState<BoardItemModel[]>([])
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(DEFAULT_LIST_COUNT)
    const [offset, setOffset] = useState(0)
    const {UIStore} = useStore()
    const navigate = useNavigate()
    const location = useLocation()
    const query = useQuery()
    const [boardType, setBoardType] = useState("")

    useEffect(()=>{
        fetchMethod()
    },[location])

    const fetchMethod = async () => {
        const urlarr= location.pathname.split("/")
        const boardType = urlarr[urlarr.length-1].toLowerCase()
        setBoardType(boardType)
        try{
            const result = await REPO.Board.GetList(boardType,{
                offset: Number(query.get("offset")),
                limit: Number(query.get("limit") || limit),
                search_query: query.get("search_query") || "",
                search_type: query.get("search_type") || "",
                // date_type: query.get("date_type") || "",
                date_begin: query.get("date_begin") || "",
                date_end: query.get("date_end") || "",
            })
            setData(result.data.list.map(info => ({...info, key: info.seq})))
            setTotal(result.data.total)
            setLimit(result.data.limit)
            setOffset(result.data.offset)
        } catch (e) {

        }
    }

    const pageChangeHandler = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<BranchListModel>) => {
        if(pagination.current && pagination.pageSize){
            query.set("offset", String((pagination.current-1) * pagination?.pageSize))
            query.set("limit", String(pagination.pageSize))
            const newQuery = queryAdd(query)
            navigate({
                pathname: location.pathname,
                search: newQuery
            })
        }
    };


    return (
        <PageWrap>
            <h3>{boardTypeText(boardType)} 목록</h3>
            <BoardList
                data={data}
                total={total}
                offset={offset}
                limit={limit}
                setLimit={setLimit}
                boardType={boardType}
                onChange={pageChangeHandler}
                fetchMethod={fetchMethod}
            />
        </PageWrap>
    )
}

export default BoardListPage